"use client"

import { useEffect } from "react"

import { AnalyticEventName, sendGoogleAnalyticsEvent } from "@modules/common/utils/analytics"

type ClientEventLoggerProps = {
  name: AnalyticEventName
  params?: Record<string, any> | null
  skip?: boolean
}

const ClientEventLogger = ({ name, params = {}, skip = false }: ClientEventLoggerProps) => {
  useEffect(() => {
    if (skip) return
    sendGoogleAnalyticsEvent(name, params)
  }, [name, params, skip])

  return null
}

export default ClientEventLogger
